import styled from 'styled-components'

export const Wrapper = styled.span`
  box-sizing: border-box;
  height: 1.25rem;
  line-height: 1.25rem;
`

Wrapper.displayName = 'Wrapper'
